import { watch, computed, ref } from '@vue/composition-api'

import useKindProperties from '@/compositions/useKindProperties'
import useKinds from '@/compositions/useKinds'
import useForm from '@/compositions/useForm'

import createSelectList from '@/utils/createSelectList'

import LocationSearch from '@/components/LocationSearch/LocationSearch'

export default {
  props: {
    address: Object,
    order: Object,
  },
  name: 'CalendarFilter',
  components: { LocationSearch },
  setup(props, context) {
    const { emit } = context
    const { $store } = context.root

    $store.dispatch('data/fetchOwnerCompanies')

    const { kinds } = useKinds(context)

    const {
      formData, getData, reactiveFormData, update,
    } = useForm({
      reactive: true,
      fields: {
        kindId: { default: '' },
        companyId: { default: '' },
        in_location_position: { default: '' },
        in_district: { default: '' },
        property_1_id: { default: '' },
        property_2_id: { default: '' },
        address: { default: { address: '', position: null } },
      },
      watcher: props.order,
    })

    const { props: [prop1, prop2], loading: propLoading } = useKindProperties({
      kindId: formData.kindId,
      property1: formData.property_1_id,
      property2: formData.property_2_id,
      context,
    })

    watch(() => reactiveFormData.value, () => emit('update', getData()), { deep: true })
    watch(() => formData.kindId.value, (kind) => {
      if (kind) return
      formData.property_1_id.value = null
      formData.property_2_id.value = null
    })

    watch(() => props.order, () => {
      update(props.order)
    })

    const formExpanded = () => ref(false)

    return {
      prop1,
      prop2,
      kinds,
      propLoading,
      formData,
      formExpanded,
      showRangeFilters: computed(() => formData?.address.value.address.length > 0),
      companies: computed(() => createSelectList($store.state.data.ownerCompanies)),
    }
  },
}
